import { render, staticRenderFns } from "./ClinicianManagement.vue?vue&type=template&id=1292c8ae&scoped=true&"
import script from "./ClinicianManagement.vue?vue&type=script&lang=js&"
export * from "./ClinicianManagement.vue?vue&type=script&lang=js&"
import style0 from "./ClinicianManagement.vue?vue&type=style&index=0&id=1292c8ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1292c8ae",
  null
  
)

export default component.exports